export default {
	install( Vue, baseUrl ) {
		Vue.prototype.$url = function( path ) {
			return baseUrl + path;
		};
	},
};
